import { Box } from '@mui/material'
import { styled } from 'styled-components'

export const StyledBox = styled(Box)`
  display: flex;
`
